import * as React from 'react';
import { isIOS, isIOS13 } from 'react-device-detect';
import { ReactComponent as DownloadIcon } from '../../../assets/svg/icons/download.svg';
import { getText } from '../../../helpers';
import logUsage from '../../../utilities/log-usage';

const DownloadFile = function DownloadFile(props: DownloadFileComponentProps) {
    const { url, keyPageId, target } = props;

    const handleClick = async (event: React.SyntheticEvent) => {
        logUsage(keyPageId);
        if (isIOS || isIOS13) {
            event.preventDefault();
            window.open(url, '_blank');
        }
    };
    return (
        <div className="download-file">
            <a
                target={target}
                href={url}
                title=""
                onClick={handleClick}
                download="Sample Data v1.csv"
                className="download-file__link"
                rel="noopener noreferrer"
                data-testid="download-file-link"
            >
                <DownloadIcon className="download-file__icon download-file__svg" />
                <span className="download-file__text">{getText('generic.download')}</span>
            </a>
        </div>
    );
};

export default React.memo(DownloadFile);
